/** @jsxImportSource @emotion/react */
import * as React from 'react';
import { CRUD_STATE } from './crudState';
import disk from '../../../assets/icons/disk.svg';
import pencil from '../../../assets/icons/pencil.svg';
import trashcan from '../../../assets/icons/trashcan.svg';
import cancel from '../../../assets/icons/xCircle.svg';
import { Row } from '../../../layout/flexbox';
import { css, SerializedStyles } from '@emotion/react';
import { HIDE, SHOW } from '../../../styles/animations';
import { CLEAR_BUTTON } from '../../../styles/styles';
import {EditMenu} from '../../../admin/userManagement/EditMenu';


type Props = {
  currentState: CRUD_STATE,
  createButtonTitle?: string,
  readButtonTitle?: string,
  updateButtonTitle?: string,
  deleteButtonTitle?: string,
  onCreate: () => void,
  onRead: () => void,
  onUpdate: () => void,
  onDelete: () => void,
  onBlock?: () => void,
  onUnblock?: () => void,
  rootCss?: SerializedStyles,
  blocked?: boolean,
  resetPassword?: boolean,
  handleResetPassword?: () => void,
}

const diskButtonCss = (currentState) => css`
  ${CLEAR_BUTTON};
  ${
  (currentState === CRUD_STATE.CREATING || currentState === CRUD_STATE.UPDATING)
  ? SHOW
  : HIDE
  };
`;

const cancelButtonCss = (currentState) => css`
${CLEAR_BUTTON};
${currentState === CRUD_STATE.UPDATING ? SHOW : HIDE};
`;

const editButtonCss = (currentState) => css`
${CLEAR_BUTTON};
${currentState === CRUD_STATE.READING ? SHOW : HIDE};
`;

const deleteButtonCss = (currentState, onBlock) => css`
${CLEAR_BUTTON};
${currentState === CRUD_STATE.READING && !onBlock ? SHOW : HIDE};
`;


/**
 * CrudButtons: a component that shows a set of buttons for creating, reading, updating, and deleting.
 * The property currentState determines which buttons are shown at any one time.
 * Create, read, update, and delete methods are passed in as props.
 * The disk button calls the create method on click.
 * The pencil button calls update on click.
 * The trashcan button calls delete on click.
 * The cancel button calls read on click.
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class CrudButtons extends React.PureComponent<Props> {
  public render() {
    return (
      <Row rootCss={this.props.rootCss} >
        { // Cancel
          <button onClick={this.props.onRead}
                  css={cancelButtonCss(this.props.currentState)}>
            <img src={cancel}
                 alt="X within Circle"
                 title={this.props.readButtonTitle}/>
          </button>
        }
        { // Save
          <button onClick={this.props.onCreate}
                  css={diskButtonCss(this.props.currentState)}>
            <img src={disk}
                 alt="Floppy Disk"
                 title={this.props.createButtonTitle}/>
          </button>
        }
        { // Edit
          <button onClick={this.props.onUpdate}
                  css={editButtonCss(this.props.currentState)}>
            <img src={pencil}
                 alt="Pencil"
                 title={this.props.updateButtonTitle}/>
          </button>
        }
        { // Delete
          <button onClick={this.props.onDelete}
                  css={deleteButtonCss(this.props.currentState, this.props.onBlock)}>
            <img src={trashcan}
                 alt="Trashcan"
                 title={this.props.deleteButtonTitle}/>
          </button>
        }
        {
          this.props.onBlock &&
          <EditMenu
            currentState={this.props.currentState}
            onDelete={this.props.onDelete}
            onBlock={this.props.onBlock}
            onUnblock={this.props.onUnblock}
            rootCss={this.props.rootCss}
            blocked={this.props.blocked}
            resetPassword={this.props.resetPassword}
            handleResetPassword={this.props.handleResetPassword}
          />
        }

      </Row>
    );
  }
}
